import {
  createQuestionnaireResponse,
  editQuestionnaireResponse,
} from "../components/api/Questionnaire";
import { semanticSnapshot } from "./questionnaireResponseUtils";

const idFromResponse = (res) =>
  res?.data?.id || res?.data?.data?.id || null;

export const createQuestionnaireResponseAutosave = ({
  create = createQuestionnaireResponse,
  edit = editQuestionnaireResponse,
  delayMs = 10000,
  onIdChange,
} = {}) => {
  let questionnaireResponseId = null;
  let lastSnapshot = null;
  let timer = null;
  let pending = Promise.resolve();
  let writeGen = 0;

  const clearTimer = () => {
    if (timer) {
      clearTimeout(timer);
      timer = null;
    }
  };

  const assignId = (nextId) => {
    if (!nextId || nextId === questionnaireResponseId) return;
    questionnaireResponseId = nextId;
    onIdChange?.(nextId);
  };

  const sendDraft = async (payload, gen) => {
    const snapshot = semanticSnapshot(payload?.questionResponse);
    if (snapshot === lastSnapshot) {
      return questionnaireResponseId;
    }

    const draftPayload = { ...payload, status: "draft" };
    const res = questionnaireResponseId
      ? await edit(questionnaireResponseId, draftPayload)
      : await create(draftPayload);

    if (gen !== writeGen) {
      return questionnaireResponseId;
    }

    assignId(questionnaireResponseId || idFromResponse(res));
    lastSnapshot = snapshot;
    return questionnaireResponseId;
  };

  return {
    getId: () => questionnaireResponseId,
    setId: (id) => {
      questionnaireResponseId = id || null;
    },
    hasPendingTimer: () => timer != null,
    schedule: (payload) => {
      const snapshot = semanticSnapshot(payload?.questionResponse);
      if (snapshot === lastSnapshot) {
        return;
      }
      clearTimer();
      timer = setTimeout(() => {
        timer = null;
        const gen = writeGen;
        pending = sendDraft(payload, gen).catch(() => {});
      }, delayMs);
    },
    cancel: () => {
      clearTimer();
      writeGen += 1;
    },
    markSaved: ({ id, questionResponse } = {}) => {
      clearTimer();
      writeGen += 1;
      if (id) {
        questionnaireResponseId = id;
      }
      lastSnapshot = semanticSnapshot(questionResponse);
    },
    flush: () => pending,
  };
};
